module.exports = __webpack_public_path__ + "img/img27.e6a07467.png";